import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { InvestmentKnowledge7 } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: InvestmentKnowledge7 & { riskProfil: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<InvestmentKnowledge7 & { riskProfil: any }> = {
      ownerId: [entity.ownerId],
      userFirstName: [entity.userFirstName],
      userLastName: [entity.userLastName],

      riskProfil: this.formBuilder.group({
        schema3: [entity?.riskProfil?.schema3 || null, Validators.required],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }

  generate(entity: InvestmentKnowledge7[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
